export const LESSON_PROGRESS_COMPLETED_EVENT = "lesson-progress:completed" as const;

export interface LessonProgressCompletedDetail {
  courseSlug: string;
  lessonSlug: string;
}
